import { getTermsAndConditions } from "../../services/api/termsandconditions.api";
import { SchedulerStoreType } from "../../state/scheduler.store";

export const setTermsAndConditions = async (
  client: string,
  actions: SchedulerStoreType["actions"]
) => {
  const tnc = await getTermsAndConditions({ client });
  if (tnc) {
    actions.setTermsAndConditions(tnc);
  }
};
